// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3GgTf","balanceDisclaimer":"posDashboard_balanceDisclaimer__1myH8"};